import { Market } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<Market>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminMarketNeighborhoodsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminMarketNeighborhoods.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getAdminMarketNeighborhoods.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getAdminMarketNeighborhoods.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getAdminMarketNeighborhoods.reset.type]: actionsHandlers.handleGetManyReset,
});

export default adminMarketNeighborhoodsReducer;
